<template>
  <div>
    <h3>Kwaliteit</h3>
    <table class="table table-condensed">
      <tbody>
        <tr>
          <th>inspectieoordeel</th>
          <td>{{ school.inspectieoordeel }}</td>
        </tr>
        <tr v-if="false">
          <th>rendement gewichtenleerlingen afgelopen drie jaar</th>
          <td>
            gemiddelde score op de eindtoets van de gewichtenleerlingen 10 keer
            rond het landelijk gemiddelde van 540
          </td>
        </tr>
        <tr v-if="false">
          <th>rendement niet-gewichtenleerlingen afgelopen drie jaar</th>
          <td>
            gemiddelde score op de eindtoets van de niet-gewichtenleerlingen 10
            keer rond het landelijk gemiddelde van 540
          </td>
        </tr>

        <tr v-if="schoolklimaatList.length">
          <th>schoolklimaat in {{ schoolklimaatList[0].schooljaar }}</th>
          <td>{{ schoolklimaatList[0].schoolklimaat }}</td>
        </tr>

        <tr v-if="leerlingoordeelList.length">
          <th>leerlingoordeel in {{ leerlingoordeelList[0].schooljaar }}</th>
          <td>{{ leerlingoordeelList[0].leerlingoordeel }}</td>
        </tr>

        <tr v-if="ouderoordeelList.length">
          <th>ouderoordeel in {{ ouderoordeelList[0].schooljaar }}</th>
          <td>{{ ouderoordeelList[0].ouderoordeel }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-param-reassign */

import scholenRepository from '../../repositories/scholenRepository';

export default {
  props: {
    school: {
      required: true,
      type: Object,
    },
    jaren: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      schoolklimaatList: [],
      leerlingoordeelList: [],
      ouderoordeelList: [],
      rendementData: {},
    };
  },
  computed: {
    schoolJaren() {
      return this.jaren.filter((j) => j.school_id === this.school.id);
    },
  },
  created() {
    const schoolklimaatList = this.schoolJaren
      .filter((j) => j.schoolklimaat)
      .map((j) => ({ schooljaar: j.schooljaar, schoolklimaat: j.schoolklimaat }));
    this.schoolklimaatList = schoolklimaatList.sort((a, b) => {
      if (a.schooljaar > b.schooljaar) {
        return -1;
      }
      return 1;
    });

    const leerlingoordeelList = this.schoolJaren
      .filter((j) => j.leerlingoordeel)
      .map((j) => ({
        schooljaar: j.schooljaar,
        leerlingoordeel: j.leerlingoordeel,
      }));
    this.leerlingoordeelList = leerlingoordeelList.sort((a, b) => {
      if (a.schooljaar > b.schooljaar) {
        return -1;
      }
      return 1;
    });

    const ouderoordeelList = this.schoolJaren
      .filter((j) => j.ouderoordeel)
      .map((j) => ({ schooljaar: j.schooljaar, ouderoordeel: j.ouderoordeel }));
    this.ouderoordeelList = ouderoordeelList.sort((a, b) => {
      if (a.schooljaar > b.schooljaar) {
        return -1;
      }
      return 1;
    });

    this.getRendementData();
  },
  methods: {
    async getRendementData() {
      const response = await scholenRepository.listSchoolRendementen();
      const rendementDatas = response.data;

      this.rendementData = _getRendementDataForSchool(
        this.school,
        rendementDatas,
      );
    },
  },
};

// doing some magic here, old code that has mostly been copied
function _bovengrens(n, gem) {
  const sem = 10 / Math.sqrt(n);
  return gem + 1.96 * sem;
}
function _ondergrens(n, gem) {
  const sem = 10 / Math.sqrt(n);
  return gem - 1.96 * sem;
}

function _getRendementDataForSchool(school, rendementDatas) {
  // for every school compute the necessary information for the rendementen
  const gewichten = [];
  const geen_gewichten = [];
  rendementDatas.forEach((rd) => {
    if (rd.sbs_scholen_id !== school.id) {
      return; // only look at rendementData for this school
    }
    rd.ng = parseFloat(rd.ng);
    rd.mg = parseFloat(rd.mg);
    rd.nzg = parseFloat(rd.nzg);
    rd.mzg = parseFloat(rd.mzg);
    if (rd.ng && rd.mg && rd.ng !== '0' && rd.mg !== '0') {
      gewichten.push({
        year: rd.year,
        ng: rd.ng,
        mg: rd.mg,
        bovengrens: _bovengrens(rd.ng, rd.mg),
        ondergrens: _ondergrens(rd.ng, rd.mg),
      });
    }
    if (rd.nzg && rd.mzg && rd.nzg !== '0' && rd.mzg !== '0') {
      geen_gewichten.push({
        year: rd.year,
        nzg: rd.nzg,
        mzg: rd.mzg,
        bovengrens: _bovengrens(rd.nzg, rd.mzg),
        ondergrens: _ondergrens(rd.nzg, rd.mzg),
      });
    }
  });
  return { gewichten, geen_gewichten };
}
</script>
